import { Typography } from'@hiver/hiver-ui-kit';

export const googleGroupPreferences = (sourceUserEmail) => ([
    {
        id: 'member',
        label: (<>
                <Typography variant='h3' component='span' fontWeight='fontWeightSemiBold'> You ({sourceUserEmail})</Typography> are a part of this Google Group.
            </>)
    },
    {
        id: 'subscription',
        label: (<>
                Your subscription is set to <Typography variant='h3' component='span' fontWeight='fontWeightSemiBold'>‘Each email’.</Typography>
            </>)
    },
    {
        id: 'posting',
        label: (<>
                Posting permission is set to <Typography variant='h3' component='span' fontWeight='fontWeightSemiBold'>‘Allowed’.</Typography>
            </>)
    }
]);
